import axios from 'axios';

/**
 * Instância Axios para rotas públicas (/api/public/*).
 * SEM interceptors de auth — tenant resolvido via query param ?host= no backend.
 *
 * O host é lido da URL do navegador: /uptime?host=acme.woli.com.br
 */
export const publicApi = axios.create({
  baseURL: `${import.meta.env.VITE_API_BASE_URL || ''}/api/public`,
  headers: { 'Content-Type': 'application/json' },
});

// Injeta ?host= em todas as requests para o backend
publicApi.interceptors.request.use((config) => {
  const host = new URLSearchParams(window.location.search).get('host');
  if (host) {
    config.params = { ...config.params, host };
  }
  return config;
});
